import type { TypePolicies } from "@apollo/client/cache/inmemory/policies";
import { prop } from "ramda";

export const typePolicies: TypePolicies = {
  RatelistNode: {
    keyFields: false,
  },
  AttributeOption: {
    keyFields: false,
  },
  PositionTagRate: {
    keyFields: false,
  },
  NationalHolidayDefinition: {
    keyFields: ["id", "country"],
    fields: {
      country: {
        read(_, { variables }) {
          return prop("country", variables) ?? null;
        },
      },
    },
  },
};
